export const EVENT_ANALYTICS_EVENTS = {
  created: "event created",
  updated: "event updated",
  canceled: "event canceled",
  registrationCreated: "event registration created",
  registrationUpdated: "event registration updated",
  registrationTransferred: "event registration transferred",
  registrationCanceled: "event registration canceled",
  waitlistPromoted: "event waitlist promoted",
  attendanceUpdated: "event attendance updated",
  attendanceFinalized: "event attendance finalized",
  scoresUpdated: "event scores updated",
  scoresFinalized: "event scores finalized",
  worksheetDownloaded: "event worksheet downloaded",
  expenseDocumentUploaded: "event expense document uploaded",
  expenseDocumentDeleted: "event expense document deleted",
  submittedForPayment: "event submitted for payment",
  recruitmentRecapUpdated: "event recruitment recap updated",
  recruitmentRecapFinalized: "event recruitment recap finalized",
  registrationsExported: "event registrations exported",
  cancellationsExported: "event cancellations exported",
  noteCreated: "event note created",
  noteUpdated: "event note updated",
  noteDeleted: "event note deleted"
} as const;

export type EventAnalyticsSource =
  | "create_event"
  | "edit_event"
  | "cancel_event"
  | "registrations"
  | "waitlist"
  | "attendance"
  | "results"
  | "payouts"
  | "recap"
  | "exports"
  | "notes";

export type EventAnalyticsData = {
  source: EventAnalyticsSource;
  success: boolean;
  eventId?: string;
  eventSlug?: string;
  registrationId?: string;
  documentId?: string;
  noteId?: string;
  action?: string;
  count?: number;
  isDraft?: boolean;
  isRecruitment?: boolean;
  issueRefund?: boolean;
  suspend?: boolean;
  attended?: boolean;
  field?: string;
  examinerFeePayee?: string;
};

export function getEventAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: EventAnalyticsSource;
  success?: boolean;
} & Omit<EventAnalyticsData, "source" | "success">): EventAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
